<template>
  <span @click.prevent="toggle()" @keypress.enter="toggle()" :class="wrapperClass">
    <input type="checkbox" :id="'check-like-' + index" v-model="checkState"/>
    <label :for="'check-like-' + index" data-button-type="zzim"><span class="a11y-hidden">{{ title }}</span></label>
  </span>
</template>
<script>
export default {
  name: 'BtnZzimTemplate',
  props: {
    title: {
      type: String,
      default: ''
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    checkState: {
      type: Boolean,
      default: false
    },
    toggleFn: {
      type: Function
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    toggle () {
      this.toggleFn(!this.checkState)
    }
  }
}
</script>
<style>

.check-like.my-like input[type="checkbox"] + label:before{
  background-size:18px;
  background-image: url(../../assets/images/common/check-my-like.png)
}

.check-like.my-like input[type="checkbox"]:checked + label:before{
  background-size:18px;
  background-image: url(../../assets/images/common/check-my-like-active.png)
}

.check-like.my-clock input[type="checkbox"] + label:before{
  background-image: url(../../assets/images/common/check-my-clock.png)
}

.check-like.my-clock input[type="checkbox"]:checked + label:before{
  background-image: url(../../assets/images/common/check-my-clock-active.png)
}

.check-like.my-subscribe input[type="checkbox"] + label:before{
  background-image: url(../../assets/images/common/check-my-plus.png)
}

.check-like.my-subscribe input[type="checkbox"]:checked + label:before{
  background-image: url(../../assets/images/common/check-my-plus-active.png)
}

.check-like.movie input[type="checkbox"] + label:before{
  background-image: url(../../assets/images/common/element-icons-30-x-30-ic-big-like-off.svg)
}

.check-like.movie input[type="checkbox"]:checked + label:before{
  background-image: url(../../assets/images/common/element-icons-30-x-30-ic-big-like-on.svg);
}

/* 마이페이지 이외 페이지 아이콘 */
.check-like.editorpick {
  /*position: absolute;*/
  /*bottom: 20px;*/
  /*right: 126px;*/
  display: block;
  width: 36px;
  height: 36px;
  margin: 0 auto;
}

.check-like.editorpick input[type="checkbox"] + label::before{
  content: '';
  display: block;
  width: 36px;
  height: 36px;
  background-image: url(../../assets/images/common/like-editer-off.png);
  background-size: 36px;
}

.check-like.editorpick input[type="checkbox"]:checked + label:before{
  background-image: url(../../assets/images/common/like-editer-on.png);
  background-size: 36px;
}

.check-like.like input[type="checkbox"] + label:before,
.check-like.movie input[type="checkbox"] + label:before{
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background: url(../../assets/images/common/element-icons-30-x-30-ic-big-like-off.svg) no-repeat center/30px 30px;
}

.check-like.like input[type="checkbox"]:checked + label:before,
.check-like.movie input[type="checkbox"]:checked + label:before{
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background: url(../../assets/images/common/element-icons-30-x-30-ic-big-like-on.svg) no-repeat center/30px 30px;
}

.check-like.clock input[type="checkbox"] + label:before{
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background: url(../../assets/images/common/ic-detail-later-off.png) no-repeat center/30px 30px;
}

.check-like.clock input[type="checkbox"]:checked + label:before{
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background: url(../../assets/images/common/ic-detail-later-on.png) no-repeat center/30px 30px;
}

.check-like.subscribe input[type="checkbox"] + label:before{
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background: url(../../assets/images/common/ic-detail-subscribe-off.png) no-repeat center/30px 30px;
}

.check-like.subscribe input[type="checkbox"]:checked + label:before{
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background: url(../../assets/images/common/ic-detail-subscribe-on.png) no-repeat center/30px 30px;
}

/* wavve추천 밴드 > 찜하기 */
.autoplay-cell .check-like.like input[type="checkbox"] + label:before,
.autoplay-cell .check-like.movie input[type="checkbox"] + label:before{
  content: "";
  display: inline-block;
  width: 34px;
  height: 34px;
  background: url(../../assets/images/common/ic-big-heart-off.png) no-repeat center/30px 30px;
}

.autoplay-cell .check-like.like input[type="checkbox"]:checked + label:before,
.autoplay-cell .check-like.movie input[type="checkbox"]:checked + label:before{
  content: "";
  display: inline-block;
  width: 34px;
  height: 34px;
  background: url(../../assets/images/common/ic-big-heart-on.png) no-repeat center/30px 30px;
}

.autoplay-cell .check-like.subscribe input[type="checkbox"] + label:before{
  content: "";
  display: inline-block;
  width: 34px;
  height: 34px;
  background: url(../../assets/images/common/ic-big-plus-off.png) no-repeat center/30px 30px;
}

.autoplay-cell .check-like.subscribe input[type="checkbox"]:checked + label:before{
  content: "";
  display: inline-block;
  width: 34px;
  height: 34px;
  background: url(../../assets/images/common/ic-big-plus-on.png) no-repeat center/30px 30px;
}
</style>
